export default __webpack_public_path__ + "static/media/TGA-light.491f039d.png";